import type { ReactElement } from "react";
import type { TimelineMilestone } from "@playbookai/widget-schemas";
import { StatusDot } from "../../atoms/index.js";
import { markerDot } from "./presentation.js";

/**
 * A milestone's marker: its kind's categorical tint, filled for a fact, a ring
 * for an estimated date and a dashed ring for a projected one. A ring is
 * filled with the card so a track line behind it never shows through.
 */
export function MilestoneDot({
  milestone,
  size,
  className,
}: {
  readonly milestone: TimelineMilestone;
  readonly size: "md" | "lg";
  /** Layout only (margin, placement). */
  readonly className?: string | undefined;
}): ReactElement {
  const { tint, variant } = markerDot(milestone);
  return variant === "solid" ? (
    <StatusDot tint={tint} size={size} className={className} />
  ) : (
    <StatusDot
      tint={tint}
      size={size}
      variant={variant}
      ringFill="card"
      className={className}
    />
  );
}
